import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_414: DocMigration = {
  maxSchemaVersion: "0.0.414",
  description: "Split up FLOOR_AREA categories to enable proper styling",
  apply(json: any) {
    for (const viewTemplateId in json.viewTemplates) {
      const viewTemplate = json.viewTemplates[viewTemplateId];
      if (viewTemplate.viewType !== "PLAN_VIEW") {
        continue;
      }
      viewTemplate.categories = replaceSheetGeometryCategories(viewTemplate.categories);
    }

    for (const effectId in json.effects) {
      const effect = json.effects[effectId];
      // effects only apply to the plan view type at the moment
      effect.categories = replaceSheetGeometryCategories(effect.categories);
    }
    return json;
  },
};

function replaceSheetGeometryCategories(categories: string[]) {
  const newCategories: string[] = [];

  const hasCategoryBeenReplaced: { [cat: string]: true } = {};

  for (const category of categories) {
    // ensure that any duplicate categories are ignored
    if (hasCategoryBeenReplaced[category]) {
      continue;
    }

    hasCategoryBeenReplaced[category] = true;

    const replacementCategories = categoryReplaceMap[category];
    if (replacementCategories) {
      newCategories.push(...replacementCategories);
    } else {
      newCategories.push(category);
    }
  }

  return newCategories;
}

const categoryReplaceMap: Record<string, string[]> = {
  FLOOR_AREAS: ["FLOOR_AREA_CONDITIONED", "FLOOR_AREA_UNCONDITIONED"],
};

export default migration_0_0_414;
